// extracted by mini-css-extract-plugin
export var container = "_2k-0";
export var error = "_2k-9";
export var label = "_2k-5";
export var light = "_2k-6";
export var md = "_2k-3";
export var sm = "_2k-2";
export var thin = "_2k-8";
export var thinBold = "_2k-7";
export var vertical = "_2k-4";
export var xs = "_2k-1";